import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=7e166e56&"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports